import { supabase } from '../supabaseClient';

export const triggerEmail = async (type, email, data = {}) => {
    try {
        const { data: response, error } = await supabase.functions.invoke('send-email', {
            body: {
                type,
                email,
                data
            }
        });

        if (error) throw error;
        return response;
    } catch (error) {
        console.error(`Error triggering ${type} email:`, error);
        // Don't throw, just log. Email failures shouldn't block UI.
        return null;
    }
};
